import { collection, getDocs, query, orderBy, where } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import type { ApplicationSource } from '../types';

export const applicationSourceService = {
  /**
   * Get all application sources
   */
  async getAllApplicationSources(): Promise<ApplicationSource[]> {
    try {
      const sourcesQuery = query(
        collection(db, 'applicationSources'),
        orderBy('order', 'asc')
      );

      const snapshot = await getDocs(sourcesQuery);
      return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      })) as ApplicationSource[];
    } catch (error) {
      console.error('Error fetching application sources:', error);
      throw error;
    }
  },

  /**
   * Get active application sources only
   */
  async getActiveApplicationSources(): Promise<ApplicationSource[]> {
    try {
      const sourcesQuery = query(
        collection(db, 'applicationSources'),
        where('isActive', '==', true),
        orderBy('order', 'asc')
      );

      const snapshot = await getDocs(sourcesQuery);
      return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      })) as ApplicationSource[];
    } catch (error) {
      console.error('Error fetching active application sources:', error);
      throw error;
    }
  },

  /**
   * Get application source by ID
   */
  async getApplicationSourceById(id: string): Promise<ApplicationSource | null> {
    try {
      const sources = await this.getAllApplicationSources();
      return sources.find(source => source.id === id) || null;
    } catch (error) {
      console.error('Error fetching application source by ID:', error);
      throw error;
    }
  },
};
